import { ref } from 'vue'

const domain = ref('');

export default function useUserHints() {
  const showDomain = (domainName) => {
    domain.value = domainName;
  }

  const toggleDomain = (domainName) => {
    domain.value = domain.value === domainName ? '' : domainName;
  }

  const resetDomain = () => {
    domain.value = '';
  }
 
  return {
    domain,
    showDomain,
    toggleDomain,
    resetDomain
  }
}
